<template>
  <div
    v-if="displayCurrentDateTime"
    :style="'left: ' + currentDateTimeLeft + ';'"
    class="calendar-content-current-datetime"></div>
</template>

<script>
export default {
  name: 'calendar-current-time',
  props: [
    'currentDateTime',
    'dateFrom',
    'dateTo'
  ],
  computed: {
    currentDateTimeUTC () {
      if (!this.currentDateTime) {
        return 0;
      }

      return this.currentDateTime.getTime() + (this.currentDateTime.getTimezoneOffset() * 60000);
    },
    dateFromTimestamp () {
      return +new Date(this.dateFrom);
    },
    dateToTimestamp () {
      return +new Date(this.dateTo);
    },
    displayCurrentDateTime () {
      return this.currentDateTimeUTC >= this.dateFromTimestamp && this.currentDateTimeUTC <= this.dateToTimestamp;
    },
    currentDateTimeLeft () {
      return (((this.currentDateTimeUTC - this.dateFromTimestamp) / (this.dateToTimestamp - this.dateFromTimestamp)) * 100) + '%';
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-content-current-datetime {
  bottom: 0;
  border-left: 2px dotted var(--danger);
  position: absolute;
  top: 80px;
  width: 0;
  z-index: 2;
}
</style>
